<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="企业名称">
            <a-input v-decorator="['companyName']" placeholder="请输入企业名称"></a-input>
          </a-form-item>
          <a-form-item label="手机号码">
            <a-input v-decorator="['phoneNumber']" placeholder="请输入手机号码"></a-input>
          </a-form-item>
          <!-- <a-form-item label="类型">
            <a-select
              class="form-control sm"
              v-decorator="['companyType']"
              placeholder="请选择"
              allowClear
              :options="typesMap.companyType"
            ></a-select>
          </a-form-item> -->
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">用户列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="doExport">
          <app-icon type="icon-daochu"></app-icon>
          导出EXCEL
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          rowKey="(record, index)=>{return index}"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import { companyType } from '@/vars'
import fileDownload from 'js-file-download'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        // dataIndex: 'userName',
        customRender: (text, row, index) => {
          return <div>{this.pageSize * (this.pageNumber - 1) + index + 1}</div>
        },
      },
      // {
      //   title: '企业名称',
      //   width: '15%',
      //   align: 'center',
      //   dataIndex: 'companyName',
      // },
      // {
      //   title: '类型',
      //   width: '10%',
      //   align: 'center',
      //   dataIndex: 'companyType',
      //   //
      //   // sortOrder: 'descend',
      //   customRender: (text, row) => {
      //     return <div>{this.translateType$t(text, 'companyType')}</div>
      //   },
      // },
      {
        title: '登录帐号',
        width: '10%',
        align: 'center',
        dataIndex: 'phoneNumber',
      },
      {
        title: '企业名称',
        width: '10%',
        align: 'center',
        dataIndex: 'companyName',
      },
      {
        title: '昵称',
        width: '10%',
        align: 'center',
        dataIndex: 'userName',
      },
      {
        title: '绑定微信',
        width: '10%',
        align: 'center',
        dataIndex: 'isWechat',
        customRender: (text) => {
          return <div>{this.translateType$t(text, 'isWechat')}</div>
        },
      },
      {
        title: '状态',
        width: '10%',
        align: 'center',

        dataIndex: 'isDisable', // 没有状态字段
        customRender: (text) => {
          return <div>{this.translateType$t(text, 'isDisable')}</div>
        },
      },
      {
        title: '创建日期',
        width: '10%',
        align: 'center',

        dataIndex: 'createTime',
      },
      {
        title: '操作',
        width: '10%',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-5 justify-center items-center text-primary-500">
              <a-button
                type="link"
                size="small"
                onClick={() => {
                  this.editRow(row)
                }}
              >
                查看
              </a-button>
              <a-button
                type="link"
                size="small"
                onClick={() => {
                  this.changeDisable(row)
                }}
              >
                {row.isDisable ? '启用' : '禁用'}
              </a-button>
              <a-button
                type="link"
                size="small"
                onClick={() => {
                  this.resetPassWord(row)
                }}
              >
                重置密码
              </a-button>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        companyType,
        isWechat: [
          { value: 0, label: '否' },
          { value: 1, label: '是' },
        ],
        isDisable: [
          { value: 0, label: '启用中' },
          { value: 1, label: '已禁用' },
        ],
      }
    },
  },
  mounted() {
    this.doQuery()
  },
  methods: {
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.get('/company/admin/companyUser/getList', {
          params: {
            ...this.form.getFieldsValue(),
            page: _pageNumber,
            limit: _pageSize,
          },
        })
        this.countTotal = Number(res.count)
        this.pageSize = _pageSize
        this.pageNumber = _pageNumber
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    async changeDisable(row) {
      const title = row.isDisable ? '确定启用帐号？' : '确定冻结帐号？'
      const content = (
        <div class="h-28 flex items-center justify-center text-red-400">
          {row.isDisable ? '你确认要启用本账号吗？' : '你确认要冻结此账号吗？冻结后该账号无法再登录。'}
        </div>
      )
      await this.$modal({
        title,
        content,
      })
      await this.$axios.post('/company/admin/companyUser/isDisable', {
        companyUserId: row.companyUserId,
        isDisable: row.isDisable ? 0 : 1,
      })
      this.$message.success('操作成功')
      this.doQuery()
    },
    async resetPassWord(row) {
      const { userName, userId, phoneNumber } = row
      const title = '确认重置账号？'
      const content = (
        <div class="pt-10 pb-10 text-center">
          确认要将【{userName}】的登录密码重置为
          <span class="text-red-500">123456</span>
          吗？
        </div>
      )
      await this.$modal({
        title,
        content,
      })
      await this.$axios.post('/user/admin/user/userResetPwd', {
        userId: userId,
        accountName: phoneNumber,
        password: '123456',
      })
      this.$message.success('操作成功')
      this.doQuery()
    },
    editRow(row) {
      this.$router.push({
        path: '/m/scopeMain/merchantUserManage/merchantUserManageDetail',
        query: {
          companyUserId: row.companyUserId,
        },
      })
    },
    async doExport() {
      const res = await this.$axios.get(`/company/admin/companyUser/download`, {
        params: {
          ...this.form.getFieldsValue(),
        },
        responseType: 'blob',
        interceptors: {
          response: false,
        },
      })
      fileDownload(res.data, '用户列表.xls')
    },
  },
}
</script>

<style lang="less"></style>
